import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import useMaterialBank from '../hooks/useMaterialBank';
import { getFinishByRouterValue, getObject } from '../services/algolia';
import { AlgoliaFinishHit, TabItem } from '../types/AlgoliaTypes';

import Tabs from '../components/layout/Tabs/Tabs';
import SwatchVariantIcon from '../components/SwatchVariantIcon/SwatchVariantIcon';

import { PLACEHOLDER_IMAGE } from '../data/constants';
import FeaturedInCard from '../components/FeaturedInCard/FeaturedInCard';
import RecommededMaterials from '../components/RecommendedMaterials/RecommendedMaterials';
import Search from '../components/Search/Search';
import InstantSearchWrapper from '../components/layout/Search/InstantSearchWrapper';
import { algoliaConfig } from '../data/config';

import { ReactComponent as DownArrow } from '../assets/images/down-arrow.svg';
import { ReactComponent as UpArrow } from '../assets/images/up-arrow.svg';
import { ReactComponent as DownloadIcon } from '../assets/images/download.svg';
import NewTag from '../components/FinishCard/NewTag';
import { compareProductLineStrings, getCategoryPage } from '../utils/utils';
import GoesWellWith from '../components/GoesWellWith/GoesWellWith';
// import UnderlinedBtn from "../components/Buttons/UnderlinedBtn";
import UtilityBtn from '../components/Buttons/UtilityBtn';
import SteelcaseImage from '../components/layout/SteelcaseImage/SteelcaseImage';

const iconMap: { [key: string]: string } = {
    'ACT Abrasion (via Symbol)': 'abrasion-low-traffic',
    'ACT Abrasion HD (via Symbol)': 'abrasion-high-traffic',
    'ACT Crocking (via Symbol)': 'wet-and-dry-crocking',
    'ACT Flame (via Symbol)': 'flamability',
    'ACT Lightfastness (via Symbol)': 'colorfastness-to-light',
    'ACT Physical Properties (via Symbol)': 'physical-properties',
};

export default function FinishDetails() {
    let { finish_code } = useParams();

    const productAvailabilitySectionRef = useRef<HTMLDivElement | null>(null);

    const navigate = useNavigate();
    const { addToCart } = useMaterialBank();
    const [finishData, setFinishData] = useState<AlgoliaFinishHit>();
    const [laminateVariantRouterVal, setLaminateVariantRouterVal] = useState<string>();
    const [showRepeat, setShowRepeat] = useState(false);
    const [showAllSwatches, setShowAllSwatches] = useState<boolean>(false);
    const [showDocuments, setShowDocuments] = useState<boolean>(true);
    const [showAltRefs, setShowAltRefs] = useState<boolean>(false);

    // const [scripts, setScripts] = useState<{ name: string; url: string; type: string; }[]>();
    // const [scriptsLoaded, setScriptsLoaded] = useState(false);
    // const [allScriptsLoaded, setAllScriptsLoaded] = useState(false);

    const handleScrollToProductAvailability = () => {
        if (productAvailabilitySectionRef.current)
            productAvailabilitySectionRef.current.scrollIntoView({
                behavior: 'smooth',
            });
    };

    const retrieveObj = async () => {
        if (finish_code) {
            const finishDataObj = await getFinishByRouterValue(finish_code);
            setFinishData(finishDataObj);

            if (!finishDataObj) {
                navigate('/finish/not-found');
            }

            if (
                finishDataObj &&
                finishDataObj.category &&
                finishDataObj.category.code === getCategoryPage('laminate_wood')
            ) {
                if (finishDataObj.pressureType)
                    finishDataObj.tabs[0].tabTitle = finishDataObj.pressureType;
                if (finishDataObj.cutType) finishDataObj.tabs[0].tabTitle = finishDataObj.cutType;

                setFinishData({
                    ...finishDataObj,
                });

                if (finishDataObj.variants && finishDataObj.variants[0]) {
                    const obj = await getObject(finishDataObj.variants[0].id);
                    setLaminateVariantRouterVal(obj.routerValue);

                    if (obj.pressureType) obj.tabs[0].tabTitle = obj.pressureType;
                    if (obj.cutType) obj.tabs[0].tabTitle = obj.cutType;
                    setFinishData({
                        ...finishDataObj,
                        tabs: finishDataObj.tabs.concat(obj.tabs[0]),
                    });
                }
            }

            if (finishDataObj && finishDataObj.tabs) {
                for (const tab of finishDataObj.tabs) {
                    let actItems: TabItem[] = [];

                    tab.tabItems = tab.tabItems.filter((item) => {
                        if (item.label.startsWith('ACT') && item.value == 'Yes') {
                            actItems.push(item);
                            return false;
                        } else if (item.label.startsWith('ACT') && item.value == 'No') {
                            return false;
                        }
                        return true;
                    });

                    if (actItems.length > 0) {
                        tab.tabItems.push({
                            label: 'ACT',
                            value: actItems.map((item) => iconMap[item.label]).join(','),
                        });
                    }
                }
            }
        }
    };

    // const configuratorRef = useRef<HTMLDivElement>(null);

    // const scriptRefs = useRef<(HTMLLinkElement | HTMLScriptElement)[]>([]);

    // useEffect(() => {
    //     const getScripts = () => {
    //         const scripts = []
    //         const CONFIGURATOR_BASE_URL = "https://configurator.steelcase.com";
    //         scripts.push({name: 'runtime_main_js', url: `${CONFIGURATOR_BASE_URL}/static/js/runtime-main.d0bf84d2.js`, type: "script" });
    //         scripts.push({name: 'chunk_js', url: `${CONFIGURATOR_BASE_URL}/static/js/2.e1c1ac34.chunk.js`, type: "script" });
    //         scripts.push({name: 'main_css', url: `${CONFIGURATOR_BASE_URL}/static/css/main.8e866735.chunk.css`, type: "link" })
    //         scripts.push({name: 'main_chunk_js', url: `${CONFIGURATOR_BASE_URL}/static/js/main.2dc7f587.chunk.js`, type: "script" });
    //         scripts.push({name: 'threekit_js', url: 'https://admin-fts.threekit.com/app/js/threekit-player.js', type: "script"});
    //         setScripts(scripts);
    //     }

    //     getScripts();
    //     setScriptsLoaded(true)
    // }, [])

    // const loadScripts = () => {
    //     scripts?.forEach((resource, idx) => {
    //         let element = null;
    //         if(resource.type === "script") {
    //             element = document.createElement("script");
    //             element.id = `sc-configurator-${resource.name}`
    //             element.src = resource.url;
    //             element.async = true;
    //         }

    //         if(resource.type === "link") {
    //             element = document.createElement("link");
    //             element.rel = "stylesheet";
    //             element.id = `sc-configurator-${resource.name}`
    //             element.href = resource.url;

    //         }

    //         if(element != null) {
    //             scriptRefs.current.push(element);
    //             document.body.appendChild(element as Node);
    //             if(idx === scripts.length - 1){
    //                 element.onload = () => setAllScriptsLoaded(true);
    //             }
    //         }

    //     });
    // }

    // useEffect(() => {
    //     if(scripts && scripts.length) {
    //         loadScripts();
    //     }

    //     return () => {
    //         scriptRefs.current.forEach((element) => {
    //             document.body.removeChild(element);
    //         })
    //     }
    // }, [scriptsLoaded])

    useEffect(() => {
        retrieveObj();
    }, [finish_code]);

    const onIconClick = (objectID: string) => {
        navigate(`../${objectID}`, { relative: 'path' });
    };

    const onTabClick = (tabTitle: string) => {
        if (
            finishData &&
            finishData.category.code === getCategoryPage('laminate_wood') &&
            laminateVariantRouterVal &&
            laminateVariantRouterVal?.length > 0 &&
            finishData.tabs[0].tabTitle !== tabTitle
        ) {
            navigate(`../${laminateVariantRouterVal}`, { relative: 'path' });
            return true;
        }
        return false;
    };

    return (
        <>
            <div
                className={'fl-container__flex fl-container__flex--white'}
                style={{ paddingTop: '20px', gap: '0px' }}
            >
                <InstantSearchWrapper indexName={algoliaConfig.MATERIAL_INDEX}>
                    <Search />
                </InstantSearchWrapper>

                {finishData ? (
                    <div
                        className={'fl-container__content fl-container__flex'}
                        style={{ paddingTop: '20px' }}
                    >
                        <div className={'finish-details__container'}>
                            <div>
                                {finishData &&
                                finishData.parentFabricFamily &&
                                finishData.parentFabricFamily.finishFiles &&
                                finishData.parentFabricFamily.finishFiles.filter(
                                    (item) => item.fileType === 'greyscale_image',
                                ).length > 0 ? (
                                    <div className="finish-details__image-controls-container">
                                        <button
                                            className={`finish-details__image-controls-text ${
                                                !showRepeat
                                                    ? 'finish-details__image-controls-text--active'
                                                    : ''
                                            }`}
                                            onClick={() => setShowRepeat(false)}
                                        >
                                            {window.steelcase_i18n['steelcase-finish-library']
                                                .flat_upholstery || 'Flat'}
                                        </button>
                                        <button
                                            className={`finish-details__image-controls-text ${
                                                showRepeat
                                                    ? 'finish-details__image-controls-text--active'
                                                    : ''
                                            }`}
                                            onClick={() => setShowRepeat(true)}
                                        >
                                            {window.steelcase_i18n['steelcase-finish-library']
                                                .repeat_upholstery || 'Repeat'}
                                        </button>
                                    </div>
                                ) : null}
                                <div className={'finish-details__image-wrapper'}>
                                    {finishData &&
                                        finishData.foeDate &&
                                        Math.floor(
                                            (new Date().getTime() -
                                                new Date(finishData.foeDate).getTime()) /
                                                (24 * 3600 * 1000),
                                        ) < 91 && <NewTag />}

                                    <SteelcaseImage
                                        src={
                                            finishData.swatch
                                                ? finishData.swatch.fileURL
                                                : PLACEHOLDER_IMAGE
                                        }
                                        altText={
                                            finishData &&
                                            finishData.swatch &&
                                            finishData.swatch.fileName
                                                ? finishData.swatch.fileName
                                                : ''
                                        }
                                        style={
                                            !showRepeat ? { display: 'block' } : { display: 'none' }
                                        }
                                        deliveryOptions={{
                                            quality: '100',
                                            width: '1000',
                                            format: 'jpeg',
                                            seoFileName: finishData?.finishName,
                                        }}
                                    />
                                    {finishData &&
                                    finishData.parentFabricFamily &&
                                    finishData.parentFabricFamily.finishFiles &&
                                    finishData.parentFabricFamily.finishFiles.filter(
                                        (item) => item.fileType === 'greyscale_image',
                                    ).length > 0 &&
                                    finishData.parentFabricFamily.finishFiles.filter(
                                        (item) => item.fileType === 'greyscale_image',
                                    )[0] ? (
                                        <SteelcaseImage
                                            src={
                                                finishData.parentFabricFamily.finishFiles.filter(
                                                    (item) => item.fileType === 'greyscale_image',
                                                ).length > 0
                                                    ? finishData.parentFabricFamily.finishFiles.filter(
                                                          (item) =>
                                                              item.fileType === 'greyscale_image',
                                                      )[0].fileURL
                                                    : PLACEHOLDER_IMAGE
                                            }
                                            altText={
                                                finishData &&
                                                finishData.swatch &&
                                                finishData.swatch.fileName
                                                    ? finishData.swatch.fileName
                                                    : ''
                                            }
                                            style={
                                                showRepeat
                                                    ? { display: 'block' }
                                                    : { display: 'none' }
                                            }
                                            deliveryOptions={{
                                                quality: '100',
                                                width: '1000',
                                                format: 'jpeg',
                                                seoFileName: finishData?.finishName,
                                            }}
                                        />
                                    ) : null}
                                </div>
                                <div className="finish-details__extra-details">
                                    <div
                                        className={`finish-details__swatch-variants-container ${
                                            showAllSwatches
                                                ? 'finish-details__swatch-show-more--open'
                                                : ''
                                        }`}
                                    >
                                        {/* {
                                            <SwatchVariantIcon 
                                                id={finishData.objectID}
                                                finishName={finishData.finishName ?? ""} 
                                                swatchURL={finishData.swatch ? finishData.swatch.fileURL  : PLACEHOLDER_IMAGE} 
                                                isActive={true} 
                                                title={`${finishData.parentFabricFamily && finishData.parentFabricFamily.familyName ? finishData.parentFabricFamily.familyName : finishData.finishName ? finishData.finishName : ""} ${finishData.filters && finishData.filters.sub_type && finishData.filters.sub_type[0] ? finishData.filters.sub_type[0] : ""} in ${finishData.finishName && finishData.finishName}`}
                                                classNames={{
                                                    icon: "finish-details__swatch-variants-icon",
                                                    active: "finish-details__swatch-variants-icon--active",
                                                    img: "finish-details__swatch-variants-img"
                                                }}
                                            />
                                        } */}
                                        {finishData.parentFabricFamily && finishData.variants &&
                                            [
                                                ...finishData.variants,
                                                {
                                                    id: finishData.objectID,
                                                    finishName: finishData.finishName ?? '',
                                                    swatchURL: finishData.swatch
                                                        ? finishData.swatch.fileURL
                                                        : PLACEHOLDER_IMAGE,
                                                    routerValue: finishData.routerValue,
                                                },
                                            ]
                                                .sort((a, b) => {
                                                    if (
                                                        a.finishName == null ||
                                                        b.finishName == null
                                                    ) {
                                                        if (
                                                            a.finishName == null &&
                                                            b.finishName == null
                                                        ) {
                                                            return 0;
                                                        } else if (a.finishName == null) {
                                                            return -1;
                                                        } else {
                                                            return 1;
                                                        }
                                                    }
                                                    return a.finishName.localeCompare(b.finishName);
                                                })
                                                .map((item, idx) => {
                                                    return (
                                                        <SwatchVariantIcon
                                                            key={idx}
                                                            id={String(item.id)}
                                                            finishName={
                                                                item.finishName
                                                                    ? item.finishName
                                                                    : item.axis
                                                                    ? item.axis
                                                                    : ''
                                                            }
                                                            swatchURL={
                                                                item.swatchURL ||
                                                                (finishData.swatch
                                                                    ? finishData.swatch.fileURL
                                                                    : PLACEHOLDER_IMAGE)
                                                            }
                                                            title={`${
                                                                finishData.parentFabricFamily &&
                                                                finishData.parentFabricFamily
                                                                    .familyName
                                                                    ? finishData.parentFabricFamily
                                                                          .familyName
                                                                    : finishData.finishName
                                                                    ? finishData.finishName
                                                                    : ''
                                                            } ${
                                                                finishData.filters &&
                                                                finishData.filters.sub_type &&
                                                                finishData.filters.sub_type[0]
                                                                    ? finishData.filters.sub_type[0]
                                                                    : ''
                                                            } in ${
                                                                item.finishName && item.finishName
                                                            }`}
                                                            onIconClickHandler={() =>
                                                                onIconClick(
                                                                    String(item.routerValue),
                                                                )
                                                            }
                                                            isActive={
                                                                finishData.routerValue ===
                                                                item.routerValue
                                                                    ? true
                                                                    : false
                                                            }
                                                            classNames={{
                                                                icon: 'finish-details__swatch-variants-icon',
                                                                active: 'finish-details__swatch-variants-icon--active',
                                                                img: 'finish-details__swatch-variants-img',
                                                            }}
                                                        />
                                                    );
                                                })}
                                    </div>
                                    {finishData.variants && finishData.variants.length > 21 ? (
                                        <button
                                            className={'finish-details__swatch-show-more-button'}
                                            onClick={() => setShowAllSwatches(!showAllSwatches)}
                                        >
                                            {showAllSwatches
                                                ? `${window.steelcase_i18n['steelcase-finish-library'].show_less} -`
                                                : `${window.steelcase_i18n['steelcase-finish-library'].show_more} +`}
                                        </button>
                                    ) : null}

                                    <span style={{ paddingBottom: '3px' }}>{`${
                                        finishData.finishName ?? ''
                                    } ${finishData.finishCode}`}</span>
                                    {/* Commented out Image Shown per request by Katie 08/19/24 */}
                                    {/* <span>{`${window.steelcase_i18n['steelcase-finish-library'].image_shown || "Image shown: "}: ${finishData && finishData.swatch && finishData.swatch.fileName ? finishData.swatch.fileName : ""}`}</span> */}
                                    <strong>
                                        {
                                            window.steelcase_i18n['steelcase-finish-library']
                                                .materials_text
                                        }
                                    </strong>
                                </div>
                            </div>
                            <div className={'finish-details__content'}>
                                <div className={'finish-details__header-container'}>
                                    <div style={{ width: '100%' }}>
                                        <span className={'finish-details__content-brand'}>
                                            {finishData.filters && finishData.filters.supplier
                                                ? finishData.filters.supplier[0]
                                                : finishData.brandNames[0]
                                                ? finishData.brandNames[0]
                                                : ''}
                                        </span>
                                        {finishData.parentFabricFamily && (
                                            <span className={'finish-details__content-family-name'}>
                                                {finishData.parentFabricFamily?.familyName}
                                            </span>
                                        )}
                                        <div
                                            className={'finish-details__alt-references-container'}
                                            onClick={() => {
                                                if (
                                                    finishData.alternateFinishReferences &&
                                                    finishData.alternateFinishReferences.length > 0
                                                ) {
                                                    setShowAltRefs(!showAltRefs);
                                                }
                                            }}
                                        >
                                            <span className={'finish-details__content-name'}>{`${
                                                finishData.finishName ?? ''
                                            } ${finishData.finishCode}`}</span>
                                            {finishData.alternateFinishReferences !== null &&
                                            finishData.alternateFinishReferences !== undefined &&
                                            finishData.alternateFinishReferences.length > 0 ? (
                                                showAltRefs ? (
                                                    <UpArrow />
                                                ) : (
                                                    <DownArrow />
                                                )
                                            ) : null}
                                        </div>
                                        {finishData.alternateFinishReferences?.map((item, idx) => {
                                            return (
                                                <span
                                                    key={`${idx}-item`}
                                                    className={`finish-details__alt-references ${
                                                        showAltRefs
                                                            ? 'finish-details__alt-references--visible'
                                                            : ''
                                                    }`}
                                                >
                                                    {item}
                                                </span>
                                            );
                                        })}
                                        {finishData.sampleItemNumber &&
                                        finishData.sampleItemNumber?.sampleItemNumberValue &&
                                        window.steelcase_finish_library.siteUrl.path == '/' ? (
                                            <UtilityBtn
                                                classNames={{
                                                    color: 'finish-details__content-add-to-cart--blue',
                                                }}
                                                onClickHandler={() =>
                                                    addToCart({
                                                        itemNumber:
                                                            finishData.sampleItemNumber
                                                                .sampleItemNumberValue,
                                                        brands: finishData.brandNames.map(
                                                            (item) => item,
                                                        ),
                                                    })
                                                }
                                                text={'Add To Cart'}
                                            ></UtilityBtn>
                                        ) : null}
                                    </div>
                                    {finishData &&
                                    finishData.productLineApplication &&
                                    finishData.productLineApplication.length > 0 ? (
                                        <UtilityBtn
                                            onClickHandler={handleScrollToProductAvailability}
                                            text={'View Product Availability'}
                                            classNames={{
                                                color: 'finish-details__content-add-to-cart--grey',
                                            }}
                                        />
                                    ) : null}
                                </div>
                                <div className={'finish-details__tabs-container'}>
                                    <div className={'finish-details__tabs-content'}></div>
                                </div>
                                {
                                    <Tabs
                                        isHighAbrasion={finishData.filters.isHighAbrasion === "Yes"}
                                        tabData={finishData.tabs}
                                        callbackOnClick={(tabTitle: string) => onTabClick(tabTitle)}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={'fl-container__content fl-container__flex'}></div>
                )}
            </div>
            {finishData && (
                <div
                    className={'fl-container__flex fl-container__flex--white'}
                    style={{ paddingBottom: '20px' }}
                >
                    {finishData && finishData.productLineApplication ? (
                        <div
                            className={
                                'finish-details__container--col-span-all fl-container__content'
                            }
                            ref={productAvailabilitySectionRef}
                        >
                            <span
                                className={
                                    'finish-details__extra-title finish-details__extra--centered'
                                }
                            >
                                {window.steelcase_i18n['steelcase-finish-library'].configurator
                                    .full_availability || 'Full Availability'}
                            </span>
                            <h3
                                className={`finish-details__extra-text finish-details__extra-text--bold`}
                            >
                                {window.steelcase_i18n['steelcase-finish-library']
                                    .product_availability.product_available_in ||
                                    'This product is available on the following product lines:'}
                            </h3>
                            <p className={`finish-details__extra-text`}>
                                {window.steelcase_i18n['steelcase-finish-library']
                                    .product_availability.HVFC ||
                                    '(H) Horizontal (V) Vertical (FC) Fire Code'}
                            </p>
                            <div className={'finish-details__extra-products-list'}>
                                {(() => {
                                    const sortedProducts = finishData.productLineApplication
                                        .flat()
                                        .slice()
                                        .sort(compareProductLineStrings);

                                    const colSize = Math.ceil(sortedProducts.length / 4);
                                    const cols = [
                                        sortedProducts.slice(0, colSize),
                                        sortedProducts.slice(colSize, colSize * 2),
                                        sortedProducts.slice(colSize * 2, colSize * 3),
                                        sortedProducts.slice(colSize * 3),
                                    ];

                                    return (
                                        <>
                                            {cols.map((col, colIdx) => {
                                                return (
                                                    <div
                                                        key={colIdx}
                                                        className="finish-details__extra-products-list--col"
                                                    >
                                                        {col.map((product, idx) => {
                                                            return (
                                                                <span
                                                                    key={`${colIdx}-${idx}}`}
                                                                    className={
                                                                        'finish-details__extra-products-item'
                                                                    }
                                                                >
                                                                    {product}
                                                                </span>
                                                            );
                                                        })}
                                                    </div>
                                                );
                                            })}
                                        </>
                                    );
                                })()}
                            </div>
                        </div>
                    ) : null}
                    {/* Out from first release */}
                    {/* <div className={"finish-details__container--col-span-all fl-container__content"}>
                                <div style={{ position: "relative"}}>
                                    <div ref={configuratorRef} id="fl-sc-product-configurator" className="sc-product-configurator l-wrapper" data-js="steelcase-configurator-wrapper"> 
                                        
                                        <div id="steelcase_configurator_root" data-currency="USD" data-exchange-rate="1" data-enable-cde="1" data-instanceid="46" data-light="true" data-catalogid="FINISHLIB" data-carouselitems="W3siTCI6IkdFU1RVUkVXUkFQM0RLTklUIn0seyJMIjoiQU1JQTNES05JVCJ9LHsiTCI6IkxFQVAzREtOSVQifV0="></div>

                                    </div>
                                </div>
                            </div> */}
                </div>
            )}
            {finishData && (
                <div
                    className="fl-container__content fl-container__flex"
                    style={{ paddingTop: '20px' }}
                >
                    {/* Featured In Palette */}
                    {finishData.paletteRelationships && finishData.paletteRelationships[0] && (
                        <div className="finish-details__container--col-span-all fl-container__content">
                            <FeaturedInCard palette_id={finishData.paletteRelationships[0]} />
                        </div>
                    )}
                    {/* Goes well with finishes block */}
                    {finishData.goesWellWithFinishes && (
                        <div className={'finish-details__container--col-span-all'}>
                            <span className={'finish-details__extra-title'}>
                                {window.steelcase_i18n['steelcase-finish-library'].goes_well_with ||
                                    'Goes well with'}
                            </span>
                            <GoesWellWith objectIDArr={finishData.goesWellWithFinishes} />
                        </div>
                    )}
                    {/* You may also like block */}
                    <div className={'finish-details__container--col-span-all'}>
                        <span className={'finish-details__extra-title'}>
                            {window.steelcase_i18n['steelcase-finish-library'].you_may_also_like ||
                                'You may also like'}
                        </span>
                        <RecommededMaterials objectID={[finishData.objectID]} limit={4} />
                    </div>
                    <div
                        className={
                            'finish-details__container--col-span-all finish-details__container--white finish-details__container--p-10'
                        }
                    >
                        <div
                            className={
                                'finish-details__collapsible-header finish-details__collapsible-panel'
                            }
                            onClick={() => setShowDocuments(!showDocuments)}
                        >
                            <h3 className={'finish-details__collapsible-header-title'}>
                                {window.steelcase_i18n['steelcase-finish-library'].document_assets
                                    ? window.steelcase_i18n['steelcase-finish-library']
                                          .document_assets
                                    : 'Documents & Assets'}
                            </h3>
                        </div>
                        {showDocuments ? (
                            <div className={'finish-details__collapsible-content'}>
                                <dl className={'finish-details__documents-list'}>
                                    <dt className={'finish-details__documents-sub-header'}>
                                        {window.steelcase_i18n['steelcase-finish-library'].documents
                                            ? window.steelcase_i18n['steelcase-finish-library']
                                                  .documents
                                            : 'Documents'}
                                    </dt>
                                    <dd className={'finish-details__documents-pdf'}>
                                        <DownloadIcon />
                                        <a
                                            onClick={(event) => {
                                                event.preventDefault();
                                                navigate(
                                                    `/finish/${finishData.routerValue}/spec_sheet`,
                                                );
                                            }}
                                            className={'finish-details__documents-download'}
                                            style={{ textDecoration: 'underline' }}
                                        >
                                            {window.steelcase_i18n['steelcase-finish-library']
                                                .spec_sheets
                                                ? window.steelcase_i18n['steelcase-finish-library']
                                                      .spec_sheets
                                                : 'Specification Sheets (PDF)'}
                                        </a>
                                    </dd>
                                    {(() => {
                                        const parentDocs =
                                            finishData?.parentFabricFamily?.finishFiles.filter(
                                                (item) => item.fileType === 'additional_documents',
                                            ) || [];
                                        const childDocs =
                                            finishData?.finishFiles?.filter(
                                                (item) => item.fileType === 'additional_documents',
                                            ) || [];

                                        const combinedDocs = [...parentDocs, ...childDocs];

                                        const uniqueDocs = Array.from(
                                            new Map(
                                                combinedDocs.map((item) => [item.fileURL, item]),
                                            ).values(),
                                        );
                                        return (
                                            <>
                                                {uniqueDocs.map((item) => {
                                                    return (
                                                        <dd
                                                            key={item.fileURL}
                                                            className="finish-details__documents-pdf"
                                                        >
                                                            <DownloadIcon />
                                                            <a
                                                                target="_blank"
                                                                href={item.fileURL}
                                                                className="finish-details__documents-download"
                                                            >
                                                                {item.fileName || ''}
                                                            </a>
                                                        </dd>
                                                    );
                                                })}
                                            </>
                                        );
                                    })()}
                                </dl>
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
}
